// Imports des traductions en anglais
import landing_en from './locales/en/landing.json';
import linkedin_en from './locales/en/linkedin.json';
import pricing_en from './locales/en/pricing.json';
import navbar_en from './locales/en/navbar.json';
import legal_en from './locales/en/legal.json';

// Imports des traductions en français
import landing_fr from './locales/fr/landing.json';
import linkedin_fr from './locales/fr/linkedin.json';
import pricing_fr from './locales/fr/pricing.json';
import navbar_fr from './locales/fr/navbar.json';
import legal_fr from './locales/fr/legal.json';

// Définition des ressources i18n
const resources = {
  en: {
    landing: landing_en,
    linkedin: linkedin_en,
    pricing: pricing_en,
    navbar: navbar_en,
    legal: legal_en
  },
  fr: {
    landing: landing_fr,
    linkedin: linkedin_fr,
    pricing: pricing_fr,
    navbar: navbar_fr,
    legal: legal_fr
  }
};

export default resources; 